import React from "react";
import dayjs from "dayjs";
import {useQuery} from "@apollo/client";

//
import {Breadcrumbs} from "../../components";

//
import {GET_ALL_MY_INVOICES} from "../../graphql/queries/dylog.query";

//
import "../Personale/Servizi/servizi.style.css";
import Loading from '../../components/Loading';
import Pagination from '../../components/pagination/pagination';

/**
 *
 */
const PersonalInvoicesPage = () => {
  const [invoiceList, setInvoiceList] = React.useState<any[]>([]);
  const [offset, setOffset] = React.useState(0);
  const limit = 10;

  const {data, loading} = useQuery(GET_ALL_MY_INVOICES, {
    variables: {
      options: {
        limit,
        offset,
      },
    },
    fetchPolicy: 'network-only',
    onCompleted(data) {
      const actualData = data?.getMyInvoices?.data ?? [];
      setInvoiceList(actualData);
    },
  });

  const breadcrumbEntries = [
    {title: "Area personale", link: "/personale"},
    {title: "Le mie fatture"},
  ];

  if (loading) return <Loading />;

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      <div className="servizi-container">
        <table className="responsive-table">
          <thead>
            <tr>
              <th>Numero fattura</th>
              <th>Data</th>
              <th>Valore</th>
              <th>Pagato</th>
            </tr>
          </thead>

          <tbody>
            {invoiceList?.map((invoice, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td data-label="Numero fattura">{invoice.invoiceNumber}</td>

                  <td data-label="Data">
                    {dayjs(invoice.date).format("DD/MM/YYYY")}
                  </td>

                  <td className="Valore">
                    {invoice.total?.toLocaleString("it-IT")}
                  </td>

                  <td className="Pagato">
                    {invoice.totalPayed?.toLocaleString("it-IT")}
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {invoiceList.length < 1 && <div className='no-items'>Nessuna fattura!</div>}
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            marginTop: '40px',
          }}
        >
          <Pagination
            total={data?.getMyInvoices?.count ?? 0}
            limit={limit}
            offset={offset}
            onChange={setOffset}
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalInvoicesPage;
